import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { WidgetTemplatesListResponse } from "@src/types/dashboards";

export interface GetWidgetTemplatesV2Result {
  success: boolean;
  data?: WidgetTemplatesListResponse;
  error?: string;
}

export const getWidgetTemplatesV2UseCase =
  async (): Promise<GetWidgetTemplatesV2Result> => {
    try {
      const authContext = store.getState().yourSlice.authContext;
      if (!authContext) {
        return { success: false, error: "Not authenticated" };
      }
      const namespace = authContext.customerNamespace;
      const response = await apiUseCases.getWidgetTemplatesV2(namespace);

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: parseAxiosApiError(error, "Failed to fetch widget templates")
          .message,
      };
    }
  };
